<template>
  <el-icon class="menu-icon" v-if="menu">
    <Folder v-if="isFolder" />
    <Document v-else />
  </el-icon>
</template>

<script setup lang="ts">
import { computed, ref, useHostAppInstance } from '@zto/zpage'
import * as ElementPlusIcons from '@element-plus/icons'

const { Folder, Document } = ElementPlusIcons

const props = withDefaults(
  defineProps<{
    menu?: any
  }>(),
  {
    menu: false
  }
)

const isFolder = computed(() => {
  return !props.menu?.path
})
</script>

<style lang="scss" scoped></style>
